import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, first, tap, take } from 'rxjs/operators';
import { ContactEntityService } from '@views/pages/apps/settings/contacts/services/contact-entity.service';


@Injectable()
export class ContactResolver implements Resolve<boolean> {

    constructor(private contactService: ContactEntityService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.contactService.loaded$.pipe(
          tap(loaded =>  {
            if(!loaded) {
              this.contactService.getAll().pipe(
                take(1)
              );
            }
          }),
          filter(loaded => !!loaded),
          first()
        );
    }

}
